import * as React from "react";

type Props = {
    start: number;
    end: number;
    renderIndex: (index: number) => React.ReactNode;
    indexCount: number;
};

export default class LargeListViewer extends React.Component<Props> {
    public render(): React.ReactNode {
        const children = [];

        const end = Math.min(this.props.end, this.props.indexCount);

        for(let i = this.props.start; i < end; i++) {
            children.push(this.props.renderIndex(i));
        }

        return children;
    }
}
